<div *ngIf="elnaeemReport != 1">
  <div *ngIf="_displayType == 1" class="container-fluid p-0">
    <div class="row">
      <div class="col-3">
        <sanabel-selectize appcode="1096" #patVisit [(ngModel)]="selectedPatient.lastVisitSerial"
          [SearchKeys]="{'PatCode':selectedPatient.code}">
        </sanabel-selectize>
      </div>
      <div class="col-3">
        <sanabel-selectize appcode="1135" #htmlTemplate [(ngModel)]="emrHtmlTemplateSerial"
          [SearchKeys]="{'ReportType':mode}" (clicked)="onTemplateSelect($event)"></sanabel-selectize>
      </div>
      <div *ngIf="showScan" class="col-3">
        <image-upload-new [documentLookupCode]="29" [autoUpdate]="true" [height]="112"
          [imageBase64]="docManagementData.base64" [docFolderLookupSerial]="4"
          [SavedId]="selectedPatient.lastVisitSerial" [transSerial]="emrHtmlReportSerial">
        </image-upload-new>
      </div>
    </div>
    <div class="col-sm-12">
      <!-- 
      <ckeditor [(ngModel)]="content" #ckeditor debounce="500">
      </ckeditor> -->
      <editor [(ngModel)]="content" [init]="editorConfig"></editor>

      <div class="row">
        <div class="col" [ngClass]="{ disabledDiv: false }">
          <btns-ctrl #btnCtrl [paramsArr]="controlsParams" [disabled]="content==null"
            (clicked)="onBtnClicked($event)"></btns-ctrl>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- --=======================================elnaeemReport==================================================== -->
<div *ngIf="elnaeemReport == 1">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-4">
        <sanabel-selectize appcode="1096" #patVisit [(ngModel)]="selectedPatient.lastVisitSerial"
          [SearchKeys]="{'PatCode':selectedPatient.code}">
        </sanabel-selectize>
      </div>
      <div class="col-4">
        <sanabel-selectize appcode="1135" #htmlTemplate [(ngModel)]="emrHtmlTemplateSerial"
          [SearchKeys]="{'ReportType':mode}" (clicked)="TemplateSelect($event)"></sanabel-selectize>
      </div>
      <div *ngIf="showPrint == 1" class="col-3" style="align-self: end; cursor: pointer;" (click)="printReportWrite()">
        <svg xmlns="http://www.w3.org/2000/svg" height="3.0em" viewBox="0 0 512 512">
          <path
            d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z" />
        </svg>
      </div>
      <!-- <div class="report-container">
      <iframe [srcdoc]="iframeSrc" width="100%" height="500px" frameborder="0"></iframe>
    </div> -->
    </div>
    <br>
    <div class="row">
      <div class="">
      </div>
      <div class="col-12">
        <textarea name="textContent" [(ngModel)]="textContent"
          style="width: 100%;height: 50vh;font-weight: bold;font-size: 12px;" placeholder="Written by Dr:"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col" [ngClass]="{ disabledDiv: false }">
        <btns-ctrl #btnCtrl [paramsArr]="controlsParams" [disabled]="content==null"
          (clicked)="onBtnClicked($event)"></btns-ctrl>
      </div>
    </div>
  </div>
</div>
<!-- --========================================================End======================================================== -->
<ul class="ulitem radilco" style="position: relative;height: 150px;" [style.top]="editableContent ? '-25px' : '0px'"
  *ngIf="_displayType == 2">
  <li *ngFor="let item of emrHTMLReports" class="radibox " [ngClass]="{'deleted-row':item.deleteStatus == 1}">

    <div class="radicon-2020 row mx-0 align-items-center">
      <span class="col-7 px-0 text-overflow-wrap">
        {{translate.currentLang=='ar'? item.nameAr : item.nameEn}}
      </span>
      <span class="datec col-4 px-0 text-center">
        {{item.regDate |date:'short'}}</span>
      <span class="fas fa-trash" style="font-size: 14px;" (click)="deleteRow(item)"></span>
    </div>
  </li>